module.exports = __webpack_public_path__ + "img/electric-furnace-heater.19271121.png";